import { IRootState } from '../reducers/rootReducer'

export const getSlides = (state: IRootState) => {
  return state.banners.slides
}

export const getInlineBanners = (state: IRootState) => {
  return state.banners.inline
}
